import React from 'react';
import { useTranslation } from 'react-i18next';
import { DESTROY_USER_SESSION_PATH } from '../util';

function DestroyUserSessionButton() {
  const { t } = useTranslation();

  return (
    <div className='test-result__button-container'>
      <a
        data-method='delete'
        data-turbolinks='false'
        href={DESTROY_USER_SESSION_PATH}
        className='
          test-result__button
          viz-btn
          viz-btn--primary
          branded__button
          branded__button--primary
        '
      >
        { t('DestroyUserSessionButton.continue') }
      </a>
    </div>
  );
}

export default DestroyUserSessionButton;
